/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * A kind of trigger the editor offers, and which choices it takes.
 */
export type TriggerKindInfo = {
  kind: string;
  label: string;
  description: string;
  about: TriggerKindInfo.about;
  options: Array<string>;
  promotional?: boolean;
  catch_up?: boolean;
};

export namespace TriggerKindInfo {
  export enum about {
    STUDENTS = "students",
    FAMILIES = "families",
    PEOPLE = "people",
    AUDIENCE = "audience",
  }
}
